// extracted by mini-css-extract-plugin
export var change = "_3c-1";
export var changeList = "_3c-0";
export var changePath = "_3c-2";
export var diffArrow = "_3c-5";
export var diffRow = "_3c-3";
export var diffValue = "_3c-4";
export var error = "_3c-8";
export var notice = "_3c-9";
export var result = "_3c-6";
export var success = "_3c-7";